import React from 'react';
import {Container, Card, Row, Col} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/styles/C911Ced.scss';
import { useSelector } from 'react-redux';
import {CabezaCedula,IdentEsc,VersionCifras,PieCedula,ClaveEsc,CicloCenso,TotalAlumnos,Separador,SumaSet,NotaAula,TurnoNombre,ActHojas} from './ToolsCed';

// control de documentos
let tothoja=0;

function PersnivelPree(cvesubnivel,docfis,docart,docleng,admvo,promotor,estiloborde){
  switch (cvesubnivel) {
    case "1":
      return (
        <Row>
          <Col xs={12}>
            <Row className="no-gutters margeninf">
              <Col xs={10} className="font-weight-bold">Personal Docente Especial</Col>
              <Col xs={2} className={`${estiloborde} text-center font-weight-bold`}>{SumaSet([docfis,docart,docleng])}</Col>
            </Row>
            <Row className="no-gutters margeninf">
              <Col xs={1} className="bordetransparente"></Col>
              <Col xs={9} className="bordetransparente">Prof. de educación física</Col>
              <Col xs={2} className={`${estiloborde} text-center`}>{docfis}</Col>
            </Row>
            <Row className="no-gutters margeninf">
              <Col xs={1} className="bordetransparente"></Col>
              <Col xs={9} className="bordetransparente">Prof. de acts. artísticas</Col>
              <Col xs={2} className={`${estiloborde} text-center`}>{docart}</Col>
            </Row>
            <Row className="no-gutters margeninf">
              <Col xs={1} className="bordetransparente"></Col>
              <Col xs={9} className="bordetransparente">Prof. de idiomas</Col>
              <Col xs={2} className={`${estiloborde} text-center`}>{docleng}</Col>
            </Row>
            <Row className="no-gutters margeninf">
              <Col xs={10} className="font-weight-bold">Pers. Admvo.,Aux. y de Servs.</Col>
              <Col xs={2} className={`${estiloborde} text-center font-weight-bold`}>{admvo}</Col>
            </Row>
          </Col>
        </Row>)
    case "3":
      return (
        <Row>
          <Col xs={12}>
            <Row className="no-gutters margeninf">
              <Col xs={10} className="font-weight-bold"><div className="bordetransparente"><p>Promotores</p></div></Col>
              <Col xs={2} className="font-weight-bold"><div className={`${estiloborde} text-center`}><p>{promotor}</p></div></Col>            
            </Row>
            <Row className="no-gutters margeninf">
              <Col xs={10} className="font-weight-bold"><div className="bordetransparente"><p>Pers. Admvo.,Aux. y de Servs.</p></div></Col>
              <Col xs={2} className="font-weight-bold"><div className={`${estiloborde} text-center`}><p>{admvo}</p></div></Col>            
            </Row>
          </Col>
        </Row>)
    default:
        return [];
  }
}

function DatosCifrasPre(props){
  const { fechac911 } = useSelector((state) => state.esc);
  let hojent=0;
  let hojfracc=0;
  let numhoja=0;
  let reg1hoja=0;
  let poselem=props.indice+1;
  if (poselem<=2){
    numhoja=1;
  }else{
    hojent=Math.trunc((poselem-2)/props.regxanexo);
    hojfracc=(poselem-2) % props.regxanexo;
    if (hojfracc>0){
      hojfracc=1;
    }
    numhoja=1+hojent+hojfracc;
  }
  if (numhoja<=1){
    reg1hoja=1;
  }else{
    reg1hoja=(numhoja-1)*props.regxanexo;
  }
  if (numhoja>tothoja){
    tothoja=numhoja;
  }
  let estilodato="";
  let estiloborde="borde";
  let descrsecci="I. ALUMNOS, GRUPOS, DOCENTES Y AULAS";
  if (fechac911[0].fuente==='CONTROL'){
    estilodato="sintexto";
    estiloborde="sinborde";
    descrsecci="I. ALUMNOS";
  }
  return (
    <div id={props.indice}>
      {Separador (poselem,reg1hoja)}
      {TurnoNombre([props.cifras.turno,props.cifras.turno1,props.cifras.turno2,props.cifras.turno3])}
      <Row><Col xs={12}><h6 className="font-weight-bold">{descrsecci}</h6></Col></Row>                        
      <Row>
        <Col xs={8}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters text-center margeninf">
                <Col xs={4}><div><p>&nbsp;</p></div></Col>
                <Col xs={1}><div><p>1°</p></div></Col>
                <Col xs={1}><div><p>2°</p></div></Col>
                <Col xs={1}><div><p>3°</p></div></Col>
                <Col xs={2}><div className={`${estilodato}`}><p>+ de 1 grado</p></div></Col>
                <Col xs={2}><div><p>Total</p></div></Col>            
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={4}><div className="bordetransparente text-left"><p>Alumnos</p></div></Col>
                <Col xs={1}><div className="borde"><p>{props.cifras.alum1}</p></div></Col>
                <Col xs={1}><div className="borde"><p>{props.cifras.alum2}</p></div></Col>
                <Col xs={1}><div className="borde"><p>{props.cifras.alum3}</p></div></Col>
                <Col xs={2}><div className={`${estilodato} ${estiloborde}`}><p>-</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.alumtot}</p></div></Col>            
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={4}><div className="bordetransparente text-left"><p>Grupos</p></div></Col>
                <Col xs={1}><div className="borde"><p>{props.cifras.grupo1}</p></div></Col>
                <Col xs={1}><div className="borde"><p>{props.cifras.grupo2}</p></div></Col>
                <Col xs={1}><div className="borde"><p>{props.cifras.grupo3}</p></div></Col>
                <Col xs={2}><div className={`${estilodato} ${estiloborde}`}><p>{props.cifras.grupon}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.grupotot}</p></div></Col>            
              </Row>
              <Row className={`no-gutters text-center margeninf ${estilodato}`}>
                <Col xs={4}><div className="bordetransparente text-left"><p>Docentes frente a grupo</p></div></Col>
                <Col xs={1}><div className={`${estiloborde}`}><p>{props.cifras.doc1}</p></div></Col>
                <Col xs={1}><div className={`${estiloborde}`}><p>{props.cifras.doc2}</p></div></Col>
                <Col xs={1}><div className={`${estiloborde}`}><p>{props.cifras.doc3}</p></div></Col>
                <Col xs={2}><div className={`${estiloborde}`}><p>{props.cifras.docn}</p></div></Col>
                <Col xs={2}><div className={`${estiloborde}`}><p>{props.cifras.doctot}</p></div></Col>            
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={2}>
          <Row className="text-center">
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={6}><div><p>Hom</p></div></Col>
                <Col xs={6}><div><p>Muj</p></div></Col>
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={6}><div className="borde"><p>{props.cifras.alumhom}</p></div></Col>
                <Col xs={6}><div className="borde"><p>{props.cifras.alummuj}</p></div></Col>          
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={2}>
          <Row className={`${estilodato}`}>
            <Col xs={12}>
              <Row className="no-gutters text-center margeninf">
                <Col xs={8}><div><p>&nbsp;</p></div></Col>
                <Col xs={4}><div><p>Aulas</p></div></Col>
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={8}><div className="bordetransparente"><p>Existentes</p></div></Col>
                <Col xs={4} className="text-center"><div className={`${estiloborde}`}><p>{props.cifras.aulaexis}</p></div></Col>          
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={8}><div className="bordetransparente"><p>En Uso</p></div></Col>
                <Col xs={4} className="text-center"><div className={`${estiloborde}`}><p>{props.cifras.aulauso}</p></div></Col>         
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={8}><div className="bordetransparente"><p>Adaptadas</p></div></Col>
                <Col xs={4} className="text-center"><div className={`${estiloborde}`}><p>{props.cifras.aulaadap}</p></div></Col>           
              </Row>
              <Row className="margensupaula">
                <Col xs={12} className="text-left">
                  <p className="fontmaspeque">{NotaAula()}</p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="margeninf">
        <Col xs={10}></Col>
        <Col xs={2} className="text-left">
          <p className="fontmaspeque">&nbsp;</p>
        </Col>
      </Row>
      <Row><Col xs={12}><h6 className={`${estilodato} font-weight-bold`}>II. PERSONAL POR FUNCIÓN</h6></Col></Row>
      <Row className={`${estilodato}`}>
        <Col xs={4}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={10} className="font-weight-bold"><div><p>Personal Directivo</p></div></Col>
                <Col xs={2} className="font-weight-bold">
                  <div className={`${estiloborde} text-center`}><p>
                    {SumaSet([props.cifras.dircgpo,props.cifras.dirsgpo,props.cifras.dirgest,props.cifras.diracad])}
                  </p></div>
                </Col>            
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={9} className="bordetransparente">Con grupo</Col>
                <Col xs={2} className={`${estiloborde} text-center`}>{props.cifras.dircgpo}</Col>            
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={9} className="bordetransparente">Sin grupo</Col>
                <Col xs={2} className={`${estiloborde} text-center`}>{props.cifras.dirsgpo}</Col>            
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={9} className="bordetransparente">Subdirector de gestión</Col>
                <Col xs={2} className={`${estiloborde} text-center`}>{props.cifras.dirgest}</Col>            
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={9} className="bordetransparente">Subdirector académico</Col>
                <Col xs={2} className={`${estiloborde} text-center`}>{props.cifras.diracad}</Col>            
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={10} className="font-weight-bold bordetransparente">Personal docente</Col>
                <Col xs={2} className={`${estiloborde} text-center font-weight-bold`}>{props.cifras.doc}</Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={4}>
          {PersnivelPree(
            props.cifras.cvesubnivel,
            props.cifras.docfis,
            props.cifras.docart,
            props.cifras.docleng,
            props.cifras.admvo,
            props.cifras.promotor,
            estiloborde)}
        </Col>
        <Col xs={4}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={7} className="font-weight-bold bordetransparente">Total de Personal</Col>
                <Col xs={2} className={`${estiloborde} text-center font-weight-bold`}>{props.cifras.perstot}</Col>            
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

function LlenaCedula(){
  //const { estad, fechac911 } = useSelector((state) => state.esc);
  const { estad } = useSelector((state) => state.esc);
  let cadena=[];
  let reg=0;
  let regcct=2;
  let regxanexo=3;
  let anexos=0;
  let anexolleno=0;
  let regsinanexo=0;
  let lianexo=0;
  let lsanexo=0;
  let cuerpo;
  const Ciclo=CicloCenso(1);
  reg=estad.length;
  ActHojas(reg,regcct,regxanexo);
  if (reg>0){
    if (reg<=2){
      cuerpo=estad.map((items,index) => <DatosCifrasPre cifras={items} regxanexo={regxanexo} indice={index} />);
      cadena.push(
      <div id='cap1'>
        <CabezaCedula/>
        <IdentEsc/>
        <Card border="dark" style={{ width: 'auto' }}>
          <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
          <Card.Body>
            <TotalAlumnos escuela={estad}/>
            {cuerpo}
          </Card.Body>
        </Card>
        <PieCedula/>
      </div>);
    }else{
      cuerpo=estad.map((items,index) => ((index>=0) && (index<=1))?<DatosCifrasPre cifras={items} regxanexo={regxanexo} indice={index}/>:[]);
      cadena.push(
        <div id='cap2'>
          <CabezaCedula/>
          <IdentEsc/>
          <Card border="dark" style={{ width: 'auto' }}>
            <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
            <Card.Body>
              <TotalAlumnos escuela={estad}/>
              {cuerpo}
            </Card.Body>
          </Card>
          <PieCedula/>
        </div>);  
      anexos=(reg-regcct)/regxanexo;
      anexolleno=Math.trunc(anexos);
      regsinanexo=reg-regcct-(anexolleno*regxanexo);
      lianexo=regcct; /* comienza a partir del registro 2 y omite los registros 0 y 1 */
      lsanexo=regcct+regxanexo-1; /* abarca hasta el 4° registro incluyendo el registro 2 */
      if (anexolleno>0) {
        //anexos llenos
        for (let ii=1; ii <= anexolleno; ii++) {
          cuerpo=estad.map((items,index) => ((index>=lianexo) && (index<=lsanexo))?<DatosCifrasPre cifras={items} regxanexo={regxanexo} indice={index}/>:[])
          cadena.push(
            <div id={ii.toString()}>
              <CabezaCedula/>
              <Card border="dark" style={{ width: 'auto'}}>
                <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
                <Card.Body>
                  <ClaveEsc cvect={estad[0].cvect}/>
                  {cuerpo}
                </Card.Body>
              </Card>
              <PieCedula/>
            </div>);
          lianexo=lianexo+regxanexo;
          lsanexo=lsanexo+regxanexo;
        }
      }else{
        lsanexo=regcct+regsinanexo-1; /* abarca hasta el registro N incluyendo el registro 2 */
      }
      if (regsinanexo>0) {
        //anexos llenos
        cuerpo=estad.map((items,index) => ((index>=lianexo) && (index<=lsanexo))?<DatosCifrasPre cifras={items} regxanexo={regxanexo} indice={index}/>:[]);
        cadena.push(
          <div id='cap4'>
            <CabezaCedula/>
            <Card border="dark" style={{ width: 'auto'}}>
              <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
              <Card.Body>
                <ClaveEsc cvect={estad[0].cvect}/>
                {cuerpo}
              </Card.Body>
            </Card>
            <PieCedula/>
          </div>);
      }
    }
  }
  return <Container padding="4rem">{cadena}</Container>;
} //LlenaCedula  

class CedPree extends React.Component {
  render(){
    return (
      <div id="capcedpree">
        <Container padding="4rem">
          <LlenaCedula/>
        </Container>
      </div>
    )
  }
}
export default CedPree;